import Factura from './classFactura'

const factura = new Factura()

// export const namespaced = true;
export const state = () => ({ ...factura.state })
export const getters = { ...factura.getters }
export const actions = { ...factura.actions }
export const mutations = { ...factura.mutations }
